import { css } from '@emotion/react';
import { useTranslations } from 'next-intl';
import { mediaQueries } from '@zapier/identity-utils';
import { atoms, colors } from '@zapier/marketing-ui';
import { ClaudeZapierLogos } from '../SignupPage/ClaudeSignUpPromo/ClaudeZapierLogos';

const styles = {
  root: css({
    padding: '24px',
    display: 'grid',
    gap: 16,
    justifyItems: 'start',
    backgroundColor: colors.neutral200,
    color: colors.neutral900,
    borderRadius: 4,

    [mediaQueries.tablet]: {
      padding: '32px 64px 32px 32px',
      gap: 24,
    },
  }),
};

export function ClaudePromo() {
  const t = useTranslations('claude-login-promo');

  return (
    <div css={styles.root}>
      <ClaudeZapierLogos />
      <h2 className={atoms.headingLG}>
        {/* eslint-disable-next-line react/display-name */}
        {t.rich('heading', { br: () => <br /> })}
      </h2>
      <p className={atoms.body}>{t('description')}</p>
    </div>
  );
}
